module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/axios/index.js
// module id = 14
// module chunks = 0 1